__turbopack_context__.v({
  "active": "_0ok91W_active",
  "buyH2": "_0ok91W_buyH2",
  "description-container": "_0ok91W_description-container",
  "intro-pricing-banner": "_0ok91W_intro-pricing-banner",
  "lingo-logo": "_0ok91W_lingo-logo",
  "mobileCarouselSection": "_0ok91W_mobileCarouselSection",
  "offerApplied": "_0ok91W_offerApplied",
  "offerFlexContainer": "_0ok91W_offerFlexContainer",
  "offerTag": "_0ok91W_offerTag",
  "offerTagBase": "_0ok91W_offerTagBase",
  "product-types": "_0ok91W_product-types",
  "products": "_0ok91W_products",
  "products-section": "_0ok91W_products-section",
  "root": "_0ok91W_root",
  "title-info-content": "_0ok91W_title-info-content",
  "transparent": "_0ok91W_transparent",
});
